import { Component, input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.html',
  styleUrls: ['./more-info.scss'],
  imports: [NzIconModule],
})
export class MoreInfoComponent {
  // Inputs converted to signal inputs
  variant = input('more-info-square');
  grouped = input(false as boolean);
  svgIcon = input<any>();
  svgIconRight = input<any>();
  blackBg = input<boolean>(false);
  fillWhite = input<boolean>(false);
  disabled = input<boolean>(false);
}
